declare var require: any;
const packageJson = require('../../package.json');

export const environment = {
    appName: 'PDR Support',
    envName: 'STAGING',
    production: true,
    algoliaAppId: 'RNHOKCEG2K',
    versions: {
        app: packageJson.version,
        angular: packageJson.dependencies['@angular/core'],
        ngrx: packageJson.dependencies['@ngrx/store'],
        material: packageJson.dependencies['@angular/material'],
        bootstrap: packageJson.dependencies.bootstrap,
        rxjs: packageJson.dependencies.rxjs,
        angularCli: packageJson.devDependencies['@angular/cli'],
        typescript: packageJson.devDependencies['typescript'],
    },
    firebasecfg: {
        apiKey: 'AIzaSyBwjQKK4fWe3mU0ckO-lwv37RTxtoRX768',
        authDomain: 'pdr-team-staging.firebaseapp.com',
        projectId: 'pdr-team-staging',
        storageBucket: 'pdr-team-staging.firebasestorage.app',
        messagingSenderId: '818446308778',
        appId: '1:818446308778:web:10ef3d09d5f15b51ce07d3',
    },
    logsConfig: {
        apiKey: 'AIzaSyDeTK3U3pFylEf9TyK9fKQLt5DdFhmOsac',
        authDomain: 'pdrcloud-logs.firebaseapp.com',
        projectId: 'pdrcloud-logs',
        storageBucket: 'pdrcloud-logs.appspot.com',
        messagingSenderId: '713672820575',
        appId: '1:713672820575:web:8e48f1373f5e45896418ea',
    },
};
